import React, { useEffect, useRef, useState } from 'react'
import './i18n';  //// import i18n (needs to be bundled ;)) 
import { useTranslation } from 'react-i18next';


const InputNumber = ({className, min, max, value, onChange }) => {


  const inputRef = useRef(null);


  const increment = () => {
    let v = Number(inputRef.current.value);
    if (v + 1 <= max) {
      onChange(v + 1);
    }
  };
  const decrement = () => {
    let v = Number(inputRef.current.value);
    if (v - 1 >= min) {
      onChange(v - 1);
    }
  };
  const handleChange = (e) => {
    const v = Number(e.target.value);
    if (v >= min && v <= max) {
      onChange(Number(e.target.value));
    }
  };
  const handleWheel = (e) => {
    let v = Number(inputRef.current.value);
    if (e.deltaY > 0) {
      decrement();
    } else {
      increment();
    }
    e.preventDefault();
  };
  return (
    <div className={`input input-number ${className ? className : ""}`}>
      <label>
        <button type="button" className='sub-control' onClick={decrement}>-</button>
        <input
            ref={inputRef}
            type="number"
            value={value}
            onChange={handleChange}
            onWheel={handleWheel}
        />
        <button type="button" className='sub-control' onClick={increment}>+</button>
      </label>
    </div>
  );
};

export default InputNumber;


